// ======================================================================
// File Name       : csvDownload
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/csvDownload';

export function receiveSelectedGroupList(selectedGroupList) {
  return {
    type: ActionTypes.CSV_RECEIVE_SELECTED_GROUP,
    selectedGroupList,
  };
}

export function changeSelectedFlag(flag) {
  return {
    type: ActionTypes.CSV_RESET_SELECTED_FLAG,
    flag,
  };
}

export function changeOpenSelectGroupFlag(flag) {
  return {
    type: ActionTypes.CSV_OPEN_SELECT_GROUP_DIALOG,
    flag,
  };
}

export function changeShowGroupFlag(flag, isLearningHistoryCSV) {
  return {
    type: ActionTypes.CSV_RESET_SHOW_GROUP_FLAG,
    flag,
    isLearningHistoryCSV,
  };
}

export function resetSelectedCourseBoxList() {
  return {
    type: ActionTypes.CSV_RESET_SELECTED_COURSE_BOX_LIST,
  };
}

export function resetSelectedGroupList() {
  return {
    type: ActionTypes.CSV_RESET_SELECTED_GROUP_LIST,
  };
}

export function receiveServiceUserList(users, recordNum, storedUserList, searchCondition) {
  return {
    type: ActionTypes.CSV_RECEIVE_SERVICE_USER_LIST,
    users,
    recordNum,
    storedUserList,
    searchCondition,
  };
}

export function receiveCourseList(courseList, recordNum, searchCondition) {
  return {
    type: ActionTypes.CSV_RECEIVE_COURSE_LIST,
    courseList,
    recordNum,
    searchCondition,
  };
}

export function receiveAddedCourseList(removedSecern, addedList = [], removedAll) {
  return {
    type: ActionTypes.CSV_RECEIVE_ADDED_COURSE_LIST,
    removedSecern,
    addedList,
    removedAll,
  };
}

export function receiveTargetCourseList(addedCourseList) {
  return {
    type: ActionTypes.CSV_RECEIVE_TARGET_COURSE_LIST,
    addedCourseList,
  };
}

export function resetData() {
  return {
    type: ActionTypes.CSV_RESET_DATA,
  };
}

export function resetContentData() {
  return {
    type: ActionTypes.CSV_RESET_CONTENT_DATA,
  };
}

export function resetUserData() {
  return {
    type: ActionTypes.CSV_RESET_USER_DATA,
  };
}

export function receiveItemList(items, recordNum, storedContentList, searchCondition) {
  return {
    type: ActionTypes.CSV_RECEIVE_ITEM_LIST,
    items,
    recordNum,
    storedContentList,
    searchCondition,
  };
}

export function receiveAddedContentList(removedSecern, addedList = [], removedAll) {
  return {
    type: ActionTypes.CSV_RECEIVE_ADDED_CONTENT_LIST,
    removedSecern,
    addedList,
    removedAll,
  };
}

export function receiveAddedUserList(removedSecern, addedList = [], removedAll) {
  return {
    type: ActionTypes.CSV_RECEIVE_ADDED_USER_LIST,
    removedSecern,
    addedList,
    removedAll,
  };
}

export function receiveTargetContentList(addedContentList) {
  return {
    type: ActionTypes.CSV_RECEIVE_TARGET_CONTENT_LIST,
    addedContentList,
  };
}

export function receiveTargetUserList(addedUserList) {
  return {
    type: ActionTypes.CSV_RECEIVE_TARGET_USER_LIST,
    addedUserList,
  };
}

export function resetCSVDownload() {
  return {
    type: ActionTypes.CSV_RESET,
  };
}

export function resetUserDialog() {
  return {
    type: ActionTypes.CSV_RESET_USER_DIALOG,
  };
}

export function resetCourseDialog() {
  return {
    type: ActionTypes.CSV_RESET_COURSE_DIALOG,
  };
}

export function resetContentDialog() {
  return {
    type: ActionTypes.CSV_RESET_CONTENT_DIALOG,
  };
}

// Step 10.0.0 START
export function receiveBoxList(boxList, recordNum, searchCondition) {
  return {
    type: ActionTypes.CSV_RECEIVE_BOX_LIST,
    boxList,
    recordNum,
    searchCondition,
  };
}

export function receiveAddedBoxList(removedSecern, addedList = [], removedAll) {
  return {
    type: ActionTypes.CSV_RECEIVE_ADDED_BOX_LIST,
    removedSecern,
    addedList,
    removedAll,
  };
}

export function receiveTargetBoxList(addedBoxList) {
  return {
    type: ActionTypes.CSV_RECEIVE_TARGET_BOX_LIST,
    addedBoxList,
  };
}

export function resetBoxData() {
  return {
    type: ActionTypes.CSV_RESET_BOX_DATA,
  };
}

export function resetBoxDialog() {
  return {
    type: ActionTypes.CSV_RESET_BOX_DIALOG,
  };
}

// Step 10.0.0 END
